var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ytplayer" },
    [
      _c(
        "modal",
        {
          key: _vm.videoData.id,
          ref: "modal_" + _vm.videoData.id,
          attrs: {
            width: _vm.modalWidth,
            height: "90%",
            maxWidth: _vm.modalMaxWidth,
            adaptive: true,
            name: _vm.videoData.id,
          },
          on: {
            "before-close": _vm.removeOverFlow,
            opened: _vm.modalOpened,
            "before-open": _vm.beforeModalOpen,
          },
        },
        [
          _c("div", { staticClass: "header" }, [
            _c("i", {
              staticClass: "fas fa-window-close",
              on: {
                click: function ($event) {
                  return _vm.$modal.hide(_vm.videoData.id)
                },
              },
            }),
          ]),
          _c(
            "div",
            {
              staticClass: "modalContentWrapper",
              class: [
                _vm.showPlaylistColumn
                  ? "contentSidebarColumn"
                  : "noContentSidebarColumn",
              ],
            },
            [
              _c("div", { class: ["contentContainer"] }, [
                _c("div", { staticClass: "youtubeWrapper" }, [
                  _c(
                    "div",
                    {
                      ref: _vm.videoData.id + "Ref",
                      staticClass: "videoPlayerContainer",
                      class: [_vm.videoLoading ? "hide" : ""],
                    },
                    [
                      _c("youtube", {
                        ref: _vm.videoData.id + "search",
                        staticClass: "youtubeComponent",
                        attrs: {
                          "player-vars": {
                            rel: 0,
                            origin: _vm.windowLocationOrigin,
                          },
                          "video-id": _vm.videoData.snippet.resourceId.videoId,
                          resize: false,
                          fitParent: true,
                          host: "https://www.youtube-nocookie.com",
                        },
                        on: {
                          error: _vm.errorYoutube,
                          ready: function ($event) {
                            return _vm.videoReady(_vm.videoData.id)
                          },
                          playing: function ($event) {
                            return _vm.videoPlaying(_vm.videoData.id)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.videoLoading && !_vm.iframeError
                    ? _c(
                        "div",
                        { staticClass: "videoPlayerContainer loadingIcon" },
                        [
                          _c(
                            "div",
                            {
                              ref: "pnLogoOuterWrapperRef",
                              staticClass: "pnLogoOuterWrapper",
                            },
                            [
                              _c("div", { staticClass: "pnLogoOuterRing" }),
                              _c("div", {
                                staticClass:
                                  "pnLogoOuterRing2 animationScaleUp",
                              }),
                              _c("div", { staticClass: "pnLogoInnerWrapper" }, [
                                _c(
                                  "svg",
                                  {
                                    staticStyle: {
                                      "enable-background":
                                        "new 0 0 141.7 141.7",
                                    },
                                    attrs: {
                                      version: "1.1",
                                      id: "Layer_1",
                                      xmlns: "http://www.w3.org/2000/svg",
                                      "xmlns:xlink":
                                        "http://www.w3.org/1999/xlink",
                                      x: "0px",
                                      y: "0px",
                                      viewBox: "0 0 141.7 141.7",
                                      "xml:space": "preserve",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        fill: "#e8b761",
                                        d: "M72.3,46.8H37.8l11.3,71.4H91l11.3-71.4H69.5l0.2-17.6h28.3l9.7-9.8c-0.8-1.6-1.3-3.5-1.3-5.4\n                                        c0-6.8,5.5-12.4,12.4-12.4c6.8,0,12.4,5.5,12.4,12.4s-5.5,12.4-12.4,12.4c-1.1,0-2.1-0.1-3-0.4l-3.2,3.3h8.1c4.9,0,8.8,4,8.8,8.8\n                                        s-4,8.8-8.8,8.8h-3.6l-3.7,23.4h3.2c1-4.8,3.4-8.1,6.3-8.1c3.7,0,6.8,5.9,6.8,13.2s-3,13.2-6.8,13.2c-2.8,0-5.3-3.3-6.3-8.1h-4.8\n                                        l-6.1,38.2c3.7,1.1,6.3,4.4,6.3,8.5c0,4.9-4,8.8-8.8,8.8H36.6c-4.9,0-8.8-4-8.8-8.8c0-4.2,2.9-7.7,6.8-8.6l-6-38.1h-4.8\n                                        c-1,4.8-3.4,8.1-6.3,8.1c-3.7,0-6.8-5.9-6.8-13.2s3-13.2,6.8-13.2c2.8,0,5.3,3.3,6.3,8.1h3.2l-3.7-23.4h-3.6c-4.9,0-8.8-4-8.8-8.8\n                                        s4-8.8,8.8-8.8h51.9L72.3,46.8L72.3,46.8z",
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.iframeError
                    ? _c(
                        "div",
                        {
                          staticClass: "videoPlayerContainer errorWrapper flex",
                        },
                        [
                          _c("div", { staticClass: "errorContainer" }, [
                            _c("div", [
                              _c("p", { staticClass: "errorTitle d-inline" }, [
                                _vm._v(
                                  _vm._s(_vm.webmessages.wsm_ccdisabledCookies)
                                ),
                              ]),
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "25",
                                    height: "25",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M24.548 10.96a11.55 11.55 0 0 0-4.478-7.702c-.6-.133-.534.44-.386.553a10.87 10.87 0 0 1 4.282 8.334 1.78 1.78 0 0 0-1.173-.44 1.79 1.79 0 0 0-1.788 1.787 1.79 1.79 0 0 0 1.788 1.788 1.8 1.8 0 0 0 .842-.21c-.358 1.394-1 2.726-1.906 3.922-5.442 7.188-16.574 5.02-19.053-3.475-.07-.237.125-.465.377-.443a4.35 4.35 0 0 0 1.87-.239 4.4 4.4 0 0 0 .788-.372c.382-.23.037-.807-.346-.578a3.74 3.74 0 0 1-.668.315 3.7 3.7 0 0 1-1.583.203c-.723-.064-1.287.6-1.084 1.303C3.445 20.558 7.926 24 13.104 24c7 0 12.323-6.334 11.444-13.04zm-1.755 3.646c-.614 0-1.113-.5-1.113-1.114s.5-1.113 1.113-1.113 1.113.5 1.113 1.113-.5 1.114-1.113 1.114zM6.806 13.532a4.43 4.43 0 0 0 .945-1.925c.02-.096.096-.17.188-.184a5.23 5.23 0 0 0 .957-.245c2.544-.907 4-3.57 3.4-6.198-.062-.264-.005-.54.155-.758.418-.57.95-1.367 1.12-1.936.12-.406.515-.66.938-.606 1.262.162 2.476.543 3.6 1.132.396.205.707-.393.3-.598a11.49 11.49 0 0 0-3.834-1.203 1.53 1.53 0 0 0-1.67 1.084c-.1.37-.47.984-1.017 1.728a1.6 1.6 0 0 0-.268 1.31 4.61 4.61 0 0 1-2.958 5.4 4.6 4.6 0 0 1-.836.213c-.365.058-.663.343-.742.7-.128.6-.405 1.164-.8 1.632-.3.344.23.773.514.435z",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M18.482 4.96c-1.06 0-1.923.862-1.923 1.923s.863 1.923 1.923 1.923 1.923-.863 1.923-1.923-.863-1.923-1.923-1.923zm0 3.172a1.25 1.25 0 0 1-1.249-1.249 1.25 1.25 0 0 1 1.249-1.249 1.25 1.25 0 0 1 1.249 1.249 1.25 1.25 0 0 1-1.249 1.249zm-4.2 4.368a1.35 1.35 0 0 0-1.349-1.349 1.35 1.35 0 0 0-1.35 1.349 1.35 1.35 0 0 0 1.35 1.349 1.35 1.35 0 0 0 1.349-1.349zm-2.024 0c0-.373.303-.675.675-.675s.675.303.675.675-.303.675-.675.675-.675-.302-.675-.675zm-7.54-4.833a1.35 1.35 0 0 0 1.349-1.349 1.35 1.35 0 0 0-1.349-1.349 1.35 1.35 0 0 0-1.349 1.349 1.35 1.35 0 0 0 1.349 1.349zm0-2.025c.373 0 .675.303.675.675s-.303.675-.675.675-.675-.303-.675-.675.302-.675.675-.675zM8.72 3.94a1.14 1.14 0 0 0 1.137-1.137A1.14 1.14 0 0 0 8.72 1.666a1.14 1.14 0 0 0-1.138 1.138A1.14 1.14 0 0 0 8.72 3.941zm0-1.6c.255 0 .463.208.463.464s-.208.463-.463.463-.463-.208-.463-.463.207-.464.463-.464zm0 6.444a1.91 1.91 0 0 0 1.908-1.908A1.91 1.91 0 0 0 8.72 4.968a1.91 1.91 0 0 0-1.908 1.908A1.91 1.91 0 0 0 8.72 8.784zm0-3.142c.68 0 1.234.554 1.234 1.234S9.4 8.1 8.72 8.1s-1.234-.554-1.234-1.234.554-1.234 1.234-1.234zm10.037 11.492c-.643 0-1.165.522-1.165 1.165s.522 1.165 1.165 1.165 1.165-.523 1.165-1.165-.523-1.165-1.165-1.165zm0 1.656a.491.491 0 1 1 0-.982.491.491 0 1 1 0 .982zM4.743 17.23c0 .775.63 1.405 1.404 1.405s1.405-.63 1.405-1.405-.63-1.404-1.405-1.404-1.404.63-1.404 1.404zm1.404-.73a.73.73 0 1 1 0 1.461.73.73 0 0 1 0-1.461zm7.168 5.127c1 0 1.833-.822 1.833-1.833s-.822-1.833-1.833-1.833-1.833.822-1.833 1.833.823 1.833 1.833 1.833zm0-3a1.16 1.16 0 0 1 1.159 1.159 1.16 1.16 0 0 1-1.159 1.159 1.16 1.16 0 0 1-1.159-1.159 1.16 1.16 0 0 1 1.159-1.159z",
                                    },
                                  }),
                                ]
                              ),
                              _c("div", { staticClass: "errorContent" }, [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.webmessages.wsm_ccneedToAcceptCookies
                                    )
                                  ),
                                ]),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.webmessages.wsm_cctoUse) +
                                      " Youtube"
                                  ),
                                ]),
                                _c(
                                  "button",
                                  {
                                    staticClass: "acceptCookiesBtn",
                                    on: { click: _vm.acceptCookiesMethod },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.webmessages.wsm_ccmodalBtnAcceptAll
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "descWrapper" }, [
                  _c("h1", {
                    staticClass: "descWrapperTitle",
                    domProps: {
                      innerHTML: _vm._s(_vm.videoData.snippet.title),
                    },
                  }),
                  _vm.showDesc
                    ? _c(
                        "p",
                        {
                          ref: "desc_" + _vm.videoData.id,
                          staticClass: "desc",
                        },
                        [
                          _c("span", {
                            staticClass: "descContent",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.textFormatter(
                                  _vm.videoData.snippet.description
                                )
                              ),
                            },
                          }),
                          !_vm.loading
                            ? _c("products", {
                                attrs: {
                                  videoId: _vm.videoData.id,
                                  tags: _vm.videoData.productIds,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm.showPlaylistColumn
                ? _c(
                    "div",
                    { class: ["contentSidebar"] },
                    _vm._l(_vm.ComputedPlaylistArray, function (video, index) {
                      return Object.keys(video.snippet.thumbnails).length > 0
                        ? _c(
                            "div",
                            {
                              key: video.id,
                              staticClass: "playlistItemWrapper",
                              on: {
                                click: function ($event) {
                                  return _vm.openVideo(_vm.nowPlaying, video.id)
                                },
                              },
                            },
                            [
                              _c("video-container", {
                                attrs: {
                                  index: index,
                                  video: video,
                                  numberOfCharacters: 40,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e()
                    }),
                    0
                  )
                : _c("div", { staticClass: "noSidebar" }),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }